import React from "react";

export class GeneralPrivacyPolicyEN extends React.Component {
    render() {
        return (
            <>
                <p>
                    Last update: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    DH Healthcare GmbH, a Dedalus Group Company, attaches a great deal of importance to and intends to pay particular attention to protecting your personal data and
                    respecting your privacy.
                    <br />
                    The aim of this privacy policy and information notice for website users (hereinafter referred to as the “notice”) is therefore to inform you of how your
                    personal data is processed when you use a DeepUnity PACSonWEB portal such as e.g., secure.pacsonweb.com (hereinafter referred to as the “site”).
                    <br />
                    In this regard, please note that Dedalus acts as the controller (controller) for your personal information (hereinafter referred to as "we", "us" and "our").
                    <br />
                    <br />
                    DH Healthcare GmbH explicitly confirms that all personal data will be processed in accordance with the Regulation 2016/679 of 27 April 2016 on the protection of
                    natural persons regarding the processing of personal data and on the free movement of such data (hereafter GDPR). This is important; therefore, we encourage you
                    to take time to read it carefully.
                </p>
                <h2>SCOPE OF THIS PRIVACY NOTICE</h2>
                <p>This Privacy Policy (Privacy Policy) applies to</p>
                <ul>
                    <li>
                        all personal data collected of Users of the DeepUnity PACSonWEB platform. This implies all doctors, dentists, specialists … that register for a DeepUnity
                        PACSonWEB account or use DeepUnity PACSonWEB through an account as well as unregistered users that logon with a reference number and date of birth for an
                        exam.
                    </li>
                    <li>any terms and conditions and other policies of DH Healthcare GmbH applicable to the Services.</li>
                </ul>
                <p>
                    This Privacy Policy does not apply to the patient data that DH Healthcare GmbH processes on demand for our contracted hospitals and radiology practices. This
                    includes both medical data generated by the radiology department and medical data made available to a radiology department by the patient himself via the upload
                    functionality. For all matters involving these data, we refer to the privacy policy of the related radiology department.
                </p>
                <h2>1. WHAT PERSONAL DATA DO WE COLLECT?</h2>
                <p>
                    When you use our portal, we may collect the following categories of personal data about you:
                    <br />
                    identification data (e.g., surname, first name, email address, username, password, Region, type of device, etc.).
                    <br />
                    professional data (e.g., position held, field of activity, employer).
                    <br />
                    technical data (e.g., IP address, type of browser used, timestamp when connecting to the portal etc.); and
                    <br />
                    any personal data contained in any correspondence you send to us.
                    <br />
                    <br />
                    Provision of your personal data is voluntary, but we will be unable to provide you with the services and information you request without it. For example, if you
                    contact us through the site, you will need to provide us with your email address so that we can respond to you.
                    <br />
                    <br />
                    In any case, we will inform you when it is mandatory to provide your personal data.
                    <br />
                    <br />
                    Additionally, if you provide us with personal data belonging to third parties, you undertake to ensure that such persons have been duly informed of the
                    processing of their personal data in accordance with this policy and, if required, have consented to the processing of their personal data.
                </p>
                <h2>2. WHY DO WE USE YOUR PERSONAL DATA?</h2>
                <p>The table below outlines the purposes that we process your personal data for and, for each purpose, the legal basis for the processing operation in question:</p>
                <table>
                    <thead>
                        <tr>
                            <th>PURPOSES</th>
                            <th>LEGAL BASIS</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registration for a user account with implementation of appropriate secure authentication and authorization methods. This implies sending e-mails
                                and/or text messages for two-factor authentication protocols;
                            </td>
                            <td>The processing is carried out based on your consent</td>
                        </tr>
                        <tr>
                            <td>Automated sending of notification mail in case new study becomes available to the user in DeepUnity PACSonWEB;</td>
                            <td>The processing is carried out based on your consent</td>
                        </tr>
                        <tr>
                            <td>Assure traceability on registered access to medical data;</td>
                            <td>The processing is necessary to comply with the legal obligations that we are subject to.</td>
                        </tr>
                        <tr>
                            <td>
                                Provide a list of registered users to hospitals that use DeepUnity PACSonWEB for distribution. This list only includes Name, First Name and
                                Identification Number as a doctor (RIZIV, BIG, ...).
                            </td>
                            <td>The processing is carried out pursuant to our legitimate interest to inform our customers on the usage of the offered services.</td>
                        </tr>
                        <tr>
                            <td>Responding to requests and questions you may submit through the site, and more broadly, managing our relationship with visitors to the site.</td>
                            <td>Contract</td>
                        </tr>
                        <tr>
                            <td>Improving and securing our services and our site.</td>
                            <td>
                                The processing is carried out pursuant to our legitimate interest, which involves optimizing and securing our tools and solutions to best
                                accommodate our site visitors, clients, and prospects and to keep our online presence secure.
                            </td>
                        </tr>
                        <tr>
                            <td>Complying with legal and regulatory obligations applicable to us.</td>
                            <td>The processing is necessary to comply with the legal obligations that we are subject to.</td>
                        </tr>
                        <tr>
                            <td>Managing any potential or actual disputes with you or third parties.</td>
                            <td>The processing is carried out pursuant to our legitimate interest, which involves defending our interests, including through legal action.</td>
                        </tr>
                        <tr>
                            <td>
                                Sending, using both automated (e.g., email, SMS, MMS, etc.) and non automated (e.g., phone, ordinary mail, etc.) means, marketing messages and
                                promotional content messages relating to our activities, products and services and those of the other Dedalus group companies (including market
                                research, customer satisfaction surveys, information about webinars and events) (marketing)
                            </td>
                            <td>The processing is carried out only in case you provide specific consent</td>
                        </tr>
                        <tr>
                            <td>
                                Transferring/Sharing your personal data to the other Dedalus group companies, operating in the bio medical sector, by automated means (e.g., email,
                                SMS, MMS, etc.), marketing messages and promotional content messages relating to their activities, products and services (including market research,
                                customer satisfaction surveys, information about webinars and events); (data transfer to third parties for their marketing purposes)
                            </td>
                            <td>The processing is carried out only in case you provide specific consent</td>
                        </tr>
                    </tbody>
                </table>
                <p>In any case, please note that we will not process your personal data for any other purpose that is incompatible with the above-mentioned purposes.</p>
                <h2>3. WHO DO WE SHARE YOUR PERSONAL DATA WITH?</h2>
                <p>
                    In the context of our processing operations, we may communicate your personal data to the following recipients:
                    <br />• to our service providers, suppliers, agents, and contractors, to the extent that they assist us in carrying out the purposes set out in this policy
                    (e.g., we use IT service providers to host your personal data on our behalf).
                    <br />• the other entities of the Dedalus Group to the extent that they assist us in carrying out the purposes set out in this policy
                    <br />• to competent courts, public authorities, government agencies and law enforcement agencies (including where we are required to comply with legal or
                    regulatory requests).
                    <br />
                    <br />
                    Regardless of the recipient, we will only disclose your personal data to them on a strictly need-to-know basis and only to the extent required to fulfill the
                    purposes identified in this policy
                    <br />
                    <br />
                    We do not sell your personal data.
                </p>
                <h2>4. DO WE TRANSFER DATA OUTSIDE THE EUROPEAN ECONOMIC AREA?</h2>
                <p>
                    For all countries within the European Economic Area, personal health data processed by DeepUnity PACSonWEB is not transferred to any country outside this area.
                </p>
                <p>
                    Should your personal data be transferred outside the European Economic Area (“EEA”), we ensure that the level of protection your personal data is given is not
                    adversely affected by such transfers.
                </p>
                <p>This specifically means that each of the intended transfers is based on one of the following mechanisms at least:</p>
                <ul>
                    <li>the existence of an adequacy decision issued by the European Commission for the country that your personal data is transferred to; or, alternatively;</li>
                    <li>the conclusion of standard contractual clauses reproducing the models adopted by the European Commission; or, alternatively;</li>
                    <li>
                        the existence of an exemption related to one of the specific situations exhaustively provided for by the General Data Protection Regulation 2016/679
                        (“GDPR”) (e.g. where you have given your consent to such transfer having been informed of the absence of safeguards, where the transfer is necessary for the
                        performance of a contract concluded between you and us, where the transfer is necessary for the conclusion or performance of a contract concluded in your
                        interest between us and a third party, or where the transfer is necessary for the establishment, exercise or defense of our legal claims, etc.).
                    </li>
                </ul>
                <h2>5. HOW LONG DO WE STORE YOUR PERSONAL DATA?</h2>
                <p>
                    We store your personal data for no longer than is necessary for the purpose of the processing concerned.
                    <br />
                    <br />
                    In other words, this means that the storage periods we apply vary depending on the purpose for which we process the data in question. The table below therefore
                    indicates, for each purpose, the storage period that will be applied to your personal data:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>PURPOSES</th>
                            <th>RETENTION TIME</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registration for a user account with implementation of appropriate secure authentication and authorization methods. This implies sending e-mails
                                and/or text messages for two-factor authentication protocols;
                            </td>
                            <td>
                                The provided personal data related to a registered user account will be stored for a period of 2 years after the last registered successful login
                                attempt.
                            </td>
                        </tr>
                        <tr>
                            <td>Automated sending of notification mail in case new study becomes available to the user in DeepUnity PACSonWEB;</td>
                            <td>
                                The provided personal data related to a registered user account will be stored for a period of 2 years after the last registered successful login
                                attempt.
                            </td>
                        </tr>
                        <tr>
                            <td>Assure traceability on registered access to medical data;</td>
                            <td>10 years</td>
                        </tr>
                        <tr>
                            <td>
                                Provide a list of registered users to hospitals that use DeepUnity PACSonWEB for distribution. This list only includes Name, First Name and
                                Identification Number as a doctor (RIZIV, BIG, ...).
                            </td>
                            <td>
                                The provided personal data related to a registered user account will be stored for a period of 2 years after the last registered successful login
                                attempt.
                            </td>
                        </tr>
                        <tr>
                            <td>Responding to requests and questions you may submit through the site, and more broadly, managing our relationship with visitors to the site.</td>
                            <td>
                                We will store your data for a maximum of one year, although in most cases your data will be aggregated shortly after collection into
                                non-identifiable statistics.
                            </td>
                        </tr>
                        <tr>
                            <td>Complying with legal and regulatory obligations applicable to us.</td>
                            <td>We store your personal data for as long as we are subject to the relevant legal or regulatory obligations.</td>
                        </tr>
                        <tr>
                            <td>Managing any potential or actual disputes with you or third parties.</td>
                            <td>Your personal data will be stored until all potential remedies have been exhausted</td>
                        </tr>
                        <tr>
                            <td>
                                Sending, using both automated (e.g., email, SMS, MMS, etc.) and non-automated (e.g., phone, ordinary mail, etc.) means, marketing messages and
                                promotional content messages relating to our activities, products and services and those of the other Dedalus group companies (including market
                                research, customer satisfaction surveys, information about webinars and events) (marketing)
                            </td>
                            <td>We will process your personal data until your consent is withdrawn.</td>
                        </tr>
                        <tr>
                            <td>
                                Transferring/Sharing your personal data to the other Dedalus group companies, operating in the bio medical sector, by automated means (e.g., email,
                                SMS, MMS, etc.), marketing messages and promotional content messages relating to their activities, products and services (including market research,
                                customer satisfaction surveys, information about webinars and events); (data transfer to third parties for their marketing purposes)
                            </td>
                            <td>We will process your personal data until your consent is withdrawn.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    In any case, once the applicable storage period has elapsed, we will irrevocably erase or anonymize your personal data so that you can no longer be identified.
                </p>
                <h2>6. DO WE USE COOKIES?</h2>
                <p>
                    We use cookies on our site.
                    <br />
                    <br />
                    To find out more about the cookies we use and the purposes that we use them for, please refer to our cookie policy, which can be found in the privacy section of
                    the website page.
                </p>
                <h2>7. WHAT RIGHTS DO YOU HAVE?</h2>
                <p>
                    In accordance with the applicable data protection legal framework, particularly the GDPR, you have the following rights as a data subject:
                    <br />• You may request access to your personal data and request that it be rectified or erased.
                    <br />• You also have the right to request that processing of your personal data be restricted or to object to the same.
                    <br />• You have the right to portability of your personal data.
                    <br />• Where processing of your personal data is based on your consent, please note that you may withdraw your consent at any time, without affecting the
                    lawfulness of processing based on your consent carried out prior to your withdrawal of the same.
                    <br />
                    However, please note that some of the above rights are subject to specific conditions dictated by the applicable data protection legal framework. So, if your
                    specific situation does not meet these conditions, we will unfortunately be unable to comply with your request.
                    <br />
                    To exercise your rights, please contact our DPO using the contact details provided in Section 7 (How can you contact us?). To process your request as
                    efficiently as possible, we may ask you for certain additional information to confirm your identity and/or assist in locating the personal data that forms the
                    subject matter of your request.
                    <br />
                    <br />
                    In any case, please note that you may lodge a complaint with the relevant Supervisory Authority. A list of European data protection authorities can be found at
                    https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm
                </p>
                <h2>8. HOW CAN YOU CONTACT US?</h2>
                <p>
                    If you have any questions or requests regarding our processing operations with your personal data under this policy, including exercising your rights, as
                    outlined above, you may contact us on the following address: dpo.group@dedalus.eu.
                    <br />
                    <br />
                    We also have appointed a data protection officer (“DPO”), which you can contact by e-mail at the following address:
                    <br />
                    for Dedalus S.p.A dpo.group@dedalus.eu
                    <br />
                    for companies based in UK dpo-uk@dedalus.group.
                    <br />
                    for companies based in France dpo.france@dedalus.eu
                    <br />
                    for companies based in Germany/Austria dpo.dach@dedalus.eu
                    <br />
                    for companies based in Italy dpo@dedalus.eu
                    <br />
                    for DH Healthcare GmbH and companies based in Belgium dpo.belgium@dedalus.eu
                    <br />
                    for other companies dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
